module.exports = {
  LINK_TYPE: {
    ACTIVATE_ACCESS: 'ACTIVATE_ACCESS',
    ACTIVATE_ACCESS_SMARTLINK: 'ACTIVATE_ACCESS_SMARTLINK',
    ACTIVATE_SMARTLINK: 'ACTIVATE_SMARTLINK',
    CONTROLLING_PARTY_AUTHORIZATION: 'CONTROLLING_PARTY_AUTHORIZATION',
    PRIMARY_USER_VERIFICATION: 'PRIMARY_USER_VERIFICATION',
    STAKEHOLDER_VERIFICATION: 'STAKEHOLDER_VERIFICATION',
    REQUEST_CONTACT_BANK_DETAILS: 'REQUEST_CONTACT_BANK_DETAILS'
  }
};
